module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/KI-1d92acbd6e726f78d21b1c0130abfd05.png";